<template>
    <div class="home-nav">
        <van-nav-bar>
            <button class="home-logo" slot="left">品书</button>
            <div class="gender-button" slot="title">
                <button :class="{ active: maleActive }" @click="changeGenderBoy">男生</button>
                <button :class="{ active: femaleActive }" @click="changeGenderGirl">女生</button>
            </div>
            <van-icon name="column" slot="right" @click="$router.push({ path: '/bookshelf' })" />
            <van-icon name="user-circle-o" slot="right" @click="$router.push({ path: '/mycenter' })" />
        </van-nav-bar>
    </div>
</template>

<script>
//             <van-image
//                 width="90"
//                 height="26"
//                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAToAAABIBAMAAACU8SQRAAAALVBMVEVHcEz////////////////////////////////////////////////////////NXt0CAAAADnRSTlMA4fGcFXjOJ7Q7WmlLh+5Ft9UAAAOBSURBVGje5ZpNaxNBGMfHJmnaWEPxIl5CDl68hIIHPZUIS/VUetBrqSAeQw5CPYUcRDwF8SaI5Oyh5C7I4lmkX0AwSV82L93PYLKZzO48u7M7MztP3OJz6TJMpj/+O/O8zRKytIYbtiPC2Q06PCYkx0+8IPH2fT6pTfStE0HXzgydGe344a6Ybs2bMFqnM89Jwfs73KID/WtAt3humnqzaekcAV22tUOh241Y1K0G6AjZ4OkI2bx+dBIWoBNZWjon03S42gH7T+iiTsXCtldI5+jTPaYDE2thT44DhqtdJ46u7CZZX3wqTn1v3EJ5s8l0Tqbpzs3QOTh0UxTtQAbV48a+yNOdZZqummm6Nsq+M0V3mmntuuHFbOqNY+gCR74Q6T8N0TVR6IBHEdCJ4ixbckAQ6eqadBuCghaJTjFHWRYt892sRidn6ejYfpxg0hFNutZyzkgxc19LPGaD9HQnyzl/EOnmTxUdukNYW2aKrgN7Grh0PbWqh22HA0S6vi4dW8vOIF2RrVVXrbb95o9nL2M8yoUmXSkUs5XobsGqRJMuOQugiEHXbsdVjHwz2Mu/8r5T65mnG9LlmpJ0ey6INDkXBkYmbCVd1UPLsijtBJGsyP7jwIbu031rnG4q0E5A95H98C7bxzWW89RN010qaRci4Ynv+3RDI3RVJe1Cb9F72+xgDLqG6Y5UtAufAM+e8s0FNqGWmm5HQbu8700eWpYV1bXaCdM981pfGlUP9Uay2u25CZn7Yjt6D1eMTrsmm9kHee02K8l07h1ZOmHvM7hmXV67H64E3cwNsh2oR5cDVZScdjddGbpZCElJtw76i9Jndl++uzjRpgvkaVdExd+1VkHX8unGJrRzjNL94gMZinbjJG8spPPj0aJolM7v9ldBtwsuJKXzOwW6qTZdgw9kqbVzjNIFfnWApd0oVK9I0hUD02ysfadNtwUCGYp2c2fg38e9tgIWX20XotqBpvfdpVw3LUyXgxdl0tqV1bTTolsHgUxeOwW6M126MghkKNrJ3TLF9T6X3U+gnfhrmbLCHaMu3QkIZFA7ZTqj2h2CQJZaO6N0HXiNh6FdX5euAQIZvBFI+kpL6jblXkeTDgYyFLrtUk2Lrii6xjNLR95o0ZVAmxeLjnz++u357weP3r96cbsm/2ZjPyK103+Vyt2FUMtbx59+Utp3M9p/RvcXlN2FjxlfktkAAAAASUVORK5CYII="
//                 slot="left"
//             />
export default {
    data() {
        return {
            maleActive: true,
            femaleActive: false
        };
    },
    components: {},
    methods: {
        changeGenderBoy() {
            if (this.maleActive == false && this.femaleActive == true) {
                this.maleActive = true;
                this.femaleActive = false;

                this.$store.commit("setChangeGender", {
                    male: this.maleActive,
                    female: this.femaleActive
                });
            } else {
                return 0;
            }
        },
        changeGenderGirl() {
            if (this.maleActive == true && this.femaleActive == false) {
                this.femaleActive = true;
                this.maleActive = false;

                this.$store.commit("setChangeGender", {
                    male: this.maleActive,
                    female: this.femaleActive
                });
            } else {
                return 0;
            }
        }
    }
};
</script>

<style lang="less">
.home-nav {
    .van-nav-bar {
        // box-sizing: border-box;
        background: rgb(184, 51, 32);
        .van-nav-bar__left {
            line-height:30px;
            left: 10px;
            button {
                border: none;
                outline: none;
                background: transparent;
                font-weight: 900;
                font-size: 40px;
                font-family: "隶书";
                color: #ffffff;
            }
        }
        .van-nav-bar__title {
            button {
                border: none;
                outline: none;
                line-height: 26px;
                border: 1px solid #ffffff;
                background: transparent;
                color: #ffffff;
                &:first-child {
                    border-radius: 26px 0 0 26px;
                }
                &:last-child {
                    border-radius: 0 26px 26px 0;
                }
                &.active {
                    background: #ffffff;
                    color: #999;
                }
            }
        }
        .van-icon {
            color: #ffffff;
            font-size: 1.5em;
            margin: 0 0 0 5px;
        }
    }
}
</style>
